export const getCellWidth = (w: any | undefined) => {
  if (!w || (typeof w === "boolean")) return "auto";
  if (w.includes("%")) return w;
  return `${Number(w) * 10}px`;
};
